import clsx from "classnames";
import classes from "../styles.module.scss";

/**
 * Header row of the table, one cell per authored column.
 *
 * @param {Array} [columns] - Column definitions; each item holds heading, width and alignment.
 * @param {string} [color] - Fill key for the header row.
 * @returns {JSX.Element|null}
 */
export default function TableHead({ columns = [], color }) {
  if (!columns?.length) return null;

  return (
    <thead>
      <tr className={classes[`fill--${color}`]} data-sourceflow-prop="columns">
        {columns.map((column, index) => (
          <th
            key={column?.id ?? index}
            scope="col"
            className={clsx(classes.table__th, column?.alignment)}
            style={{ width: column?.width && column.width !== "auto" ? column.width : undefined }}
          >
            {column?.heading}
          </th>
        ))}
      </tr>
    </thead>
  );
}
